import { GoToFeatureWebComponent } from './component/GoToFeatureWebComponent';

export { GoToFeatureWebComponent };
